module.exports = __webpack_public_path__ + "img/24.5ced77a4.png";